import {
  TOGGLE_LOADING,
  AMA_TOGGLE_LOADING,
  FETCH_MAIN_CHAT_LISTING,
  FETCH_HISTORY_CHAT_LISTING,
  FETCH_CANNED_DOCS
} from "../../constants/QueryZoiActionTypes";


  const initialState = {
    loading: false,
    ama_loading:false,
    chat_history: null,
    chat_listing: null,
    canned_docs:null,
  }

  const queryZoiReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case TOGGLE_LOADING:
        return { ...state, loading: payload };
      case AMA_TOGGLE_LOADING:
        return { ...state, ama_loading: payload };
      case FETCH_HISTORY_CHAT_LISTING:
        return { ...state, chat_history: payload };
      case FETCH_MAIN_CHAT_LISTING:
        return { ...state, chat_listing: payload };
      case FETCH_CANNED_DOCS:
        return { ...state, canned_docs: payload };
      default:
        return state;
    }
  };

  export default queryZoiReducer;
